import { useCheckMarketingOptinMutation } from 'global/services/mutations/useCheckMarketingOptinMutation/useOptinStatusMutation';

enum OptinStatus {
  DENIED = 0,
  ACCEPTED = 1,
  NOT_FOUND = 2,
}

export const useCheckCustomerMarketingOptinStatus = () => {
  const { data, mutate, isLoading, isSuccess, isError } =
    useCheckMarketingOptinMutation();

  const checkMarketingOptinStatus = (
    taxvat: string,
    onSuccessCallback?: ({ isNewClient }: { isNewClient: boolean }) => void
  ) => {
    mutate(
      { taxvat },
      {
        onSuccess: (data) =>
          onSuccessCallback?.({
            isNewClient: data?.opt?.status === OptinStatus.NOT_FOUND,
          }),
      }
    );
  };

  return {
    checkMarketingOptinStatus,
    isError,
    isLoading,
    isSuccess,
    isNewClient: isSuccess && data?.opt?.status === OptinStatus.NOT_FOUND,
    showMarketingOptin: isSuccess && data?.opt?.status === OptinStatus.DENIED,
  };
};
